module.exports = __webpack_public_path__ + "static/img/texture-turquoise.69002a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/texture-turquoise.png
// module id = NqWt
// module chunks = 0